// API DOC = https://swiperjs.com/swiper-api
import Swiper from 'swiper/bundle';
import {findMany} from '../helpers';

// Configuration options for the fade Swiper instances
const options = {
    grabCursor: false,
    loop: false,
    mousewheel: {
        thresholdDelta: 10,
        forceToAxis: true,
    },
    parallax: true,
    resistance: false,
    roundLengths: true,
    slidePrevClass: 'is-invisible',
    slideVisibleClass: 'is-visible',
    slidesPerView: 'auto',
    spaceBetween: 0,
    speed: 400,
    threshold: 10,
    breakpoints: {
        1024: {
            allowTouchMove: false,
            speed: 800,
        },
    },
};

// Find all elements with the 'data-swipe-multiview' attribute
const elements = findMany('[data-swipe-multiview]');

elements.forEach((element) => {
    const slides = element.children.length;

    if (slides < 1) {
        return null;
    }

    return new Swiper(element, {
        ...options,
        navigation: {
            nextEl: findMany('[data-swiper-next]', element),
            prevEl: findMany('[data-swiper-prev]', element),
            disabledClass: 'opacity-0',
        },
    });
});
